
import { Vue, Prop, Watch } from "vue-property-decorator";
import ListViewItem from "./ListViewItem";

export default class Tirscript3ListViewItem extends Vue {
  @Prop({ default: null, type: String }) title!: string;
  // параметры
  @Prop({ default: null, type: Object }) item!: ListViewItem<any>;
  @Prop({ default: false, type: Boolean }) multi!: boolean;
  @Prop({ default: "box", type: String }) typeView: string;
  @Prop({ default: true, type: Boolean }) selected!: boolean;
  @Prop({ default: true, type: Boolean }) hovered!: boolean;
  @Prop({ default: true, type: Boolean }) disabled!: boolean;
  @Prop({ default: true, type: Boolean }) selectAccess!: boolean;

  innerTypeView: string;
  hover: boolean = false;

  // методы
  created() { }
  mounted() {
    this.innerTypeView = this.typeView;
  }

  mouseover() {
    if (this.hovered) this.hover = true;
  }
  mouseleave() {
    if (this.hovered) this.hover = false;
  }
  click(value: any) {
    if (!this.item.Disabled && this.selectAccess) {
      this.item.Selected = !this.item.Selected;
      this.$emit("select", this.item);
    }
  }
  isHover() {
    // debugger
    return this.hover && !this.isDisabled();
  }
  isSelected() {
    return !this.isHover() && this.item.Selected;
  }
  isDisabled() {
    return this.item.Disabled;
  }
  isDefault() {
    return !this.isHover() && !this.isSelected();
  }
  currentClass() {
    if (this.hover) return "hover";
    if (this.item.Selected) return "selected";
  }
  dragStart(value: DragEvent) {
    if (this.item.Disabled) {
      return;
    }
    value.dataTransfer.effectAllowed = "move";
    value.dataTransfer.setData(
      "application/x-javascript",
      JSON.stringify(this.item)
    );
    this.$emit("itemDragStart", this.item, value);
  }

  dragEnd(value: any) {
    this.$emit("itemdropend", this.item, value);
  }
  dragDrop(value: any) {
    value.preventDefault();
    this.$emit("itemdrop", this.item, value);
  }
}
